import { CheckCircle2, Circle, History } from 'lucide-react';
import * as React from 'react';

import { cn } from '../../lib/cn';

export interface ChecklistRowProps {
	/** Descrizione della voce di checklist. */
	label: React.ReactNode;
	/** Se true, la voce è completata (icona di spunta verde). */
	done: boolean;
	/** Testo mostrato a destra quando completata. Default: "Caricato". */
	doneLabel?: React.ReactNode;
	/** Testo mostrato a destra quando mancante. Default: "Mancante". */
	missingLabel?: React.ReactNode;
}

/** Riga bordata con stato di completamento a sinistra e testo di stato a destra (es. checklist documenti). */
const ChecklistRow = ({
	label,
	done,
	doneLabel = 'Caricato',
	missingLabel = 'Mancante',
}: ChecklistRowProps) => (
	<div className="flex items-center justify-between rounded-lg border border-border bg-background/50 px-3 py-2">
		<span className="flex items-center gap-2 text-[13px] text-text">
			{done ? (
				<CheckCircle2 className="h-3.5 w-3.5 text-accent-green" />
			) : (
				<Circle className="h-3.5 w-3.5 text-text-muted" />
			)}
			{label}
		</span>
		<span className={cn('text-[12px]', done ? 'text-accent-green' : 'text-text-muted')}>
			{done ? doneLabel : missingLabel}
		</span>
	</div>
);
ChecklistRow.displayName = 'ChecklistRow';

export interface TimelineRowProps {
	/** Testo principale della voce. */
	title: React.ReactNode;
	/** Testo secondario attenuato (es. data/autore). */
	meta?: React.ReactNode;
	/** Icona iniziale. Default: icona "storico". */
	icon?: React.ReactNode;
}

/** Voce bordata di uno storico/audit trail: icona, riga di titolo, riga meta attenuata. */
const TimelineRow = ({ title, meta, icon }: TimelineRowProps) => (
	<li className="flex gap-3 rounded-lg border border-border bg-background/50 px-3 py-2">
		<span className="mt-0.5 shrink-0 text-accent [&_svg]:h-3.5 [&_svg]:w-3.5">
			{icon ?? <History />}
		</span>
		<div className="min-w-0 flex-1">
			<div className="text-[13px] text-text">{title}</div>
			{meta && <div className="text-[11px] text-text-muted">{meta}</div>}
		</div>
	</li>
);
TimelineRow.displayName = 'TimelineRow';

export { ChecklistRow, TimelineRow };
